'use client'

import { Spacer, Text } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useAsset } from '@marketplace-web/shared/assets'

import AboutFactBlock from '../AboutFactBlock/AboutFactBlock'

const AboutFactSection = () => {
  const translate = useTranslate('about_mission.facts')
  const asset = useAsset('/assets/about/icons')

  return (
    <>
      <Spacer size={Spacer.Size.X4Large} />
      <div className="u-tablets-up-only">
        <Spacer size={Spacer.Size.X4Large} />
      </div>
      <div className="about__section">
        <Text as="h2" alignment={Text.Alignment.Left} width={Text.Width.Parent}>
          <span className="c-text--responsive-large-heading">{translate('title')}</span>
        </Text>
        <Spacer size={Spacer.Size.X2Large} />
        <div className="u-tablets-up-only">
          <Spacer size={Spacer.Size.X2Large} />
        </div>
        <div className="about__facts">
          <AboutFactBlock
            imageSource={asset('light-bulb.svg', { theme: { dark: 'light-bulb-dark.svg' } })}
            blockHeading={translate('beginning.title')}
            blockText={translate('beginning.text')}
          />
          <div className="u-phones-only">
            <Spacer size={Spacer.Size.X2Large} />
          </div>
          <AboutFactBlock
            imageSource={asset('globe.svg', { theme: { dark: 'globe-dark.svg' } })}
            blockHeading={translate('team.title')}
            blockText={translate('team.text')}
          />
        </div>
        <Spacer size={Spacer.Size.X2Large} />
        <div className="u-tablets-up-only">
          <Spacer size={Spacer.Size.X2Large} />
        </div>
        <div className="about__facts">
          <AboutFactBlock
            imageSource={asset('hanger.svg', { theme: { dark: 'hanger-dark.svg' } })}
            blockHeading={translate('working.title')}
            blockText={translate('working.text')}
          />
          <div className="u-phones-only">
            <Spacer size={Spacer.Size.X2Large} />
          </div>
          <AboutFactBlock
            imageSource={asset('hand-ok.svg', { theme: { dark: 'hand-ok-dark.svg' } })}
            blockHeading={translate('mission.title')}
            blockText={translate('mission.text')}
          />
        </div>
      </div>
    </>
  )
}

export default AboutFactSection
